import { EXTERNAL_LINKS } from '@cast/constants';
import {
  ExternalLink,
  mergeSx,
  SxProps,
  Box,
  tokens,
} from '@cast/design-system';
import { useTrial } from '@cast/shared-trial-ui';

import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';
import { ContentContainer } from 'main-layout/ContentContainer';

type AccountOnHoldHeaderProps = {
  sx?: SxProps;
};

export const AccountOnHoldHeader = ({ sx }: AccountOnHoldHeaderProps) => {
  const accountReadOnly = useIsOrganizationReadOnly();
  const { isEligible } = useTrial();

  if (
    !accountReadOnly ||
    isEligible // trial eligible users see TrialViewerBanner.tsx banner
  ) {
    return null;
  }

  return (
    <Box
      sx={mergeSx(
        {
          height: 48,
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: tokens.theme.bg.status.errorStrong,
          fontWeight: 600,
          color: tokens.theme.fg.status.onErrorStrong,
        },
        sx
      )}
    >
      <ContentContainer>
        Thank you for coming back!{' '}
        <ExternalLink link={EXTERNAL_LINKS.castai_contact_us} noIcon>
          Contact us
        </ExternalLink>{' '}
        for a new 30-day trial and discover SLOs, reliability, and cost
        optimization.
      </ContentContainer>
    </Box>
  );
};
